import Marionette from 'backbone.marionette';
import { BusinessDetailView, Props } from 'components/businessDetailView'
import { IEsApiEntity as Entity } from 'models/esResult'
import * as _ from 'underscore'
import * as React from "react";
import ReactWrapper from 'views/marionetteReactWrapper';
import LayoutView from 'views/layoutView'
import { IKbApiEntity } from 'models/kbApiEntity'

class BusinessesDetailController extends Marionette.Controller {
  initialize(opts: { business?: IKbApiEntity }) {
    if (opts.business) {
      this.business = opts.business
    }
    this.view = new LayoutView()
    this.listenTo(this.view, 'render', () => this.renderView())
  }

  private renderView(additionalOpts?: object) {
    const props = this.buildProps(additionalOpts)
    const sidebarView = new ReactWrapper({
      getComponent: () => (<BusinessDetailView {...props} />)
    });
    this.view.showView(sidebarView);
  }

 private buildProps(additionalProps?: object): object {
    let props: Props = {}
    if (this.business && this.business.data) {
      props['business'] = this.business
    }
    return _.extend(props, additionalProps)
  }
}

export default BusinessesDetailController;